import { observer } from 'mobx-react-lite'
import { PlanIncludesTooltip } from 'pages/settings/ui/BillingPlan/ui/PlanIncludesTooltipContent/PlanIncludesTooltipContent'

type SeatPlanIncludesTooltipProps = {
  additionalSeatPrice: string
}

export const SeatPlanIncludesTooltip = observer(
  ({ additionalSeatPrice }: SeatPlanIncludesTooltipProps) => {
    return (
      <PlanIncludesTooltip
        items={[
          { label: '1st seat:', value: 'FREE' },
          { label: 'Additional seats:', value: additionalSeatPrice },
        ]}
      />
    )
  }
)
